export default __webpack_public_path__ + "static/media/001-earthquake.7aeea0fb.svg";